import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/App/context/AuthContext";
import nextImg from "src/assets/next.svg";
import "./style.scss";

const SignIn = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [newPasswordConfirm, setNewPasswordConfirm] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [pendingUser, setPendingUser] = useState(null);
  const { signIn, completeNewPassword } = useAuth();
  const navigate = useNavigate();

  const onClickNext = async () => {
    if (!email || !password) return;
    setError("");
    setLoading(true);
    try {
      const result = await signIn(email, password);
      if (result.newPasswordRequired) {
        setPendingUser(result.cognitoUser);
      } else {
        navigate(result.role === "admin" ? "/admin" : "/dashboard");
      }
    } catch (err) {
      setError(
        err.code === "NotAuthorizedException" || err.code === "UserNotFoundException"
          ? "Incorrect email or password."
          : err.message || "An error occurred. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const onCompleteNewPassword = async () => {
    if (!newPassword || newPassword !== newPasswordConfirm) {
      setError("Passwords do not match.");
      return;
    }
    setError("");
    setLoading(true);
    try {
      const result = await completeNewPassword(pendingUser, newPassword);
      navigate(result.role === "admin" ? "/admin" : "/dashboard");
    } catch (err) {
      setError(err.message || "Failed to set password.");
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") pendingUser ? onCompleteNewPassword() : onClickNext();
  };

  if (pendingUser) {
    return (
      <div className="login-page">
        <div className="content">
          {error && <p className="error-message">{error}</p>}
          <p className="prompt">Set a new password to continue.</p>
          <input
            type="password"
            placeholder="new password"
            value={newPassword}
            onChange={e => setNewPassword(e.target.value)}
            onKeyDown={handleKeyDown}
            autoFocus
          />
          <br />
          <input
            type="password"
            placeholder="confirm password"
            value={newPasswordConfirm}
            onChange={e => setNewPasswordConfirm(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <div className="control-div">
            <span />
            <img
              src={nextImg}
              alt="next"
              onClick={onCompleteNewPassword}
              className={loading ? "loading" : ""}
            />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-page">
      <div className="content">
        {error && <p className="error-message">{error}</p>}
        <input
          type="text"
          placeholder="email"
          value={email}
          onChange={e => setEmail(e.target.value)}
          onKeyDown={handleKeyDown}
          autoFocus
        />
        <br />
        <input
          type="password"
          placeholder="password"
          value={password}
          onChange={e => setPassword(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <div className="control-div">
          <span onClick={() => navigate("/reset")}>reset password</span>
          <img
            src={nextImg}
            alt="next"
            onClick={onClickNext}
            className={loading ? "loading" : ""}
          />
        </div>
      </div>
    </div>
  );
};

export default SignIn;
